<template>
	<label class="inline-block">
		<input :value="term" placeholder="Search Help" type="search" class="outline-0 w-full block py-10 pl-48 pr-24 border-2 border-white hover:border-goGrayBrighter rounded-full placeholder:text-goGrayDark bg-iconSearch  bg-left-12" @input="updateTerm" />
	</label>
</template>

<script>
import Vue from "vue"; // eslint-disable-line
import fuse from "fuse.js";
import { faqs } from "~/static/data/faq";

Vue.prototype.$fuseSearch = function (term, list, options) {
	return new Promise(function (resolve, reject) {
		// eslint-disable-next-line
		const run = new fuse(list, options);
		const results = run.search(term);
		resolve(results);
	});
};
export default {
	data() {
		return {
			options: {
				keys: ["question", "answer"],
				minMatchCharLength: 3,
				tokenize: true,
				shouldSort: true,
				threshold: 0.1,
				matchAllTokens: true,
			},
			results: [],
		};
	},
	computed: {
		term() {
			return this.$store.state.help.searchTerm;
		},
	},
	methods: {
		updateTerm(e) {
			const self = this;
			if (e.target.value) {
				self.options.minMatchCharLength = self.term.length;
				self.$fuseSearch(self.term, faqs, self.options).then((result) => {
					self.$store.commit("help/updateResults", result);
				});
			} else {
				self.$store.commit("help/updateResults", []);
			}

			self.$store.commit("help/updateSearchTerm", e.target.value);
		},
	},
};
</script>
